const state = {
    list: [
        { value: 'Фізична особа', id: 0, key: 'natural', profileLabel: 'Профіль фізичної особи' },
        { value: 'Юридична особа', id: 1, key: 'legal', profileLabel: 'Профіль юридичної особи' },
        { value: 'Landing', id: 2, key: 'landing' },
        { value: 'Landing Partners', id: 4, key: 'landing_partners' },
        { value: 'API', id: 5, key: 'api' },
    ],
};

const getters = {
    USER_TYPES: state => state.list
};

export default {
    state,
    getters
};
